import { END } from './channel';
import createSaga from './createSaga';
import {
	all,
	// race,
	call,
	fork,
	take,
	put,
	putResolve,
	get,
	delay,
	cancel,
	cancelled,
} from './effect';

const takeEvery = (pattern, saga, ...args) =>
	fork(function* () {
		while (true) {
			const action = yield take(pattern);
			yield fork(saga, ...args.concat(action));
		}
	});

// EXPORT
export default createSaga;
export {
	END,
	// effect
	all,
	// race,
	call,
	fork,
	take,
	takeEvery,
	put,
	putResolve,
	get,
	delay,
	cancel,
	cancelled,
};

export { eventChannel } from './eventChannel';
